import React, {FC} from 'react';

export const RatSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#EA596E"
          d="M30 36H6c-.552 0-1-.447-1-1s.448-1 1-1h24c2.542 0 4-1.367 4-3.75 0-1.537-1.643-3.25-4-3.25h-7c-.553 0-1-.447-1-1s.447-1 1-1h7c3.589 0 6 2.715 6 5.25 0 3.493-2.355 5.75-6 5.75z"/>
    <path fill="#66757F"
          d="M12 24.5c0-3.037 3.604-5.938 1-7.5-3.407-2.044-6.879 4.293-9 5-3 1-4 3.407-4 5 0 1.838 1.986 1.725 5 2 1.906.175 5.594.125 9 1 2.942.756-2-2.462-2-5.5z"/>
    <path fill="#66757F" d="M33 23.5C33 15 29.247 11 24 11c-10 0-14 7-14 14 0 5.247 6.753 6 12 6s11-2.253 11-7.5z"/>
    <path fill="#8899A6"
          d="M9.781 17.844c0-2.594-2.375-3.219-1.188-5.031.706-1.078 2.588-.635 3.051-.582-.037 1.332 1.605 1.875 2.054 1.049.378.372.71.83.962 1.361.914 1.923-.461 4.49-1.958 5.201-1.494.711-2.921.132-2.921-1z"/>
    <circle fill="#292F33" cx="26.5" cy="16.5" r="1.5"/>
  </svg>
);

export const OxSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#C1694F"
          d="M33.912 14.37C33.588 12.602 31.976 11 30 11H9c-1 0-5.325.035-6 2L.691 19.305C.016 21.27 1 24.087 3.027 24.087c1.15 0 2.596-.028 3.998-.052C10.016 28.046 12.898 36 14 36c.849 0 1.572-3.414 1.862-6h11.25c.234 2.528.843 6 1.888 6 .954 0 2.977-4.301 4.136-10.917.431-1.901.726-4.418.824-7.647.024.172.04.356.04.564v9c0 .553"/>
    <path fill="#662113"
          d="M11 25.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"/>
    <circle fill="#292F33" cx="7.5" cy="16.5" r="1.5"/>
  </svg>
);

export const TigerSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FFAC33"
          d="M32.338 16.852c-.367-.33-.818-.592-1.338-.852-2-1-5 0-9 0-2 0-3.901-3-9-3-.801 0-2.256.635-4.341.89C8.62 12.837 8.044 12 7.333 12 6.597 12 6 12.895 6 14c0 .051.007.1.01.15C3.19 14.916 0 18.589 0 20.375 0 22.375 2 24 2 24s2.171-1 5-1h3l1 10s-1 1-2 1-1 2-1 2h6l1-8h3c2 0 6-1 6-1 2 3 4 4 4 4v2l-2 1c-2 1-1 2-1 2h6s1-8 2-13c.232-1.162.353-2.101.382-2.881.396.549.618 1.183.618 1.881 0 2.93 0 5.697-1.832 8.445-.307.46-.183 1.08.277 1.387.171.113.364.168.554.168.323 0 .641-.156.833-.445C36 28.303 36 25.099 36 22c0-2.297-1.396-4.137-3.662-5.148z"/>
    <circle fill="#292F33" cx="5" cy="17" r="1.5"/>
    <path fill="#292F33" d="M0 20s0 2 1 2c0-2 1-2 1-2s-1-1-2 0zm16 5c2.154-2.872 2.759-7.794 2.93-10.348"/>
  </svg>
);

export const RabbitSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#99AAB5" d="M9 11C9 6.858 7 0 8 0s7 4 5 11c-1.138 3.983-.896 4-2 4s-2 .142-2-4z"/>
    <path fill="#F4ABBA"
          d="M9.55 11.704c0-3.414-1.297-9.065-.648-9.065.648 0 4.538 3.296 3.241 9.065-.738 3.282-.581 3.296-1.297 3.296s-1.296.117-1.296-3.296z"/>
    <path fill="#99AAB5"
          d="M4.789 12.375C3.726 8.372.033 2.256 1 2c.966-.257 7.792 2.07 7.655 9.349-.078 4.142.161 4.096-.907 4.379-1.068.283-1.897.65-2.959-3.353z"/>
    <path fill="#E1E8ED" d="M28 20c0-6.627-5.373-12-12-12S4 13.373 4 20s5.373 12 12 12 12-5.373 12-12z"/>
    <circle fill="#292F33" cx="21.5" cy="18.5" r="1.5"/>
  </svg>
);

export const DragonSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#3E721D"
          d="M12.434 29.833c.626-6.708-4.417-7.542-6.417-6.083-1.097.8-1.353 2.323-.479 1.521 1.542-1.416 2.083-.375.917.375s-1.375 2.145-.083 1.188c1.292-.958 1.646-.334.646.895-.605.744.042 1.438 1.167-.062.938-1.251 3.2-1.294 2.662 2.99-.222 1.756 1.453.608 1.587-.824zm7.941-21.022c-.583-3.5-1.125-5.248-4.625-5.832s-6.417 1.75-6.417 1.75.583-3.5 2.333-4.667c.686-.458 1.167 1.75 1.75 1.75s1.167-1.75 2.917-1.75"/>
    <path fill="#77B255" d="M30 18c0-6.627-5.373-12-12-12S6 11.373 6 18s5.373 12 12 12 12-5.373 12-12z"/>
    <circle fill="#292F33" cx="22.5" cy="16.5" r="1.5"/>
  </svg>
);

export const SnakeSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#DD2E44"
          d="M11.84 7.634c-.719 0-2.295 2.243-3.567 1.029-.44-.419 1.818-1.278 1.727-2.017-.075-.607-2.842-1.52-1.875-2.099.967-.578 2.418.841 3.513.866 2.382.055 4.212-.853 4.238-.866"/>
    <path fill="#77B255"
          d="M27.818 36c-3.967 0-8.182-2.912-8.182-8.308 0-1.374-.89-1.661-1.637-1.661-.746 0-1.636.287-1.636 1.661 0 5.396-4.216 8.308-8.182 8.308S0 33.23 0 27.692C0 14.4 14.182 12.565 14.182 1"/>
    <circle fill="#292F33" cx="8" cy="10" r="1.5"/>
  </svg>
);

export const HorseSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#8A4B38"
          d="M23.875 19.375s-.628 2.542.187 5.03c.145.341.049.556-.208.678-.256.122-4.294 1.542-4.729 1.771-.396.208-1.142 1.78-1.208 2.854.844.218 1.625.104 1.625.104s.025-1.915.208-2.042c.183-.127 5.686-1.048 6.062-1.771"/>
    <path fill="#C1694F"
          d="M27.188 11.188c-3.437.156-7.207.438-9.5.438-3.655 0-5.219-1.428-6.562-2.625C8.838 6.964 8.167 4.779 6 5.501c0 0-.632-.411-1.247-.778"/>
    <circle fill="#292F33" cx="12" cy="12" r="1.5"/>
  </svg>
);

export const GoatSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FFAC33"
          d="M7.44 7.503c-1-4 3.687-6 8-4 .907.421.948 1.316 0 1-3-1-6 1-4 4 1.109 1.664-3.233 2.068-4-1z"/>
    <path fill="#E1E8ED" d="M28 18c0-5.523-4.477-10-10-10S8 12.477 8 18s4.477 10 10 10 10-4.477 10-10z"/>
    <circle fill="#292F33" cx="22.5" cy="16.5" r="1.5"/>
  </svg>
);

export const MonkeySvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#BF6952"
          d="M29 1c-4.139 0-6 3.509-6 6 0 2.57 2.43 5 5 5 1.92 0 3.468-1.28 3.766-3.113.232-1.426-.437-3.165-2.449-3.836-.528-.176-1.09.109-1.265.632-.175.524.108 1.09.632 1.265"/>
    <path fill="#D99E82" d="M27 19c0-4.971-4.029-9-9-9s-9 4.029-9 9 4.029 9 9 9 9-4.029 9-9z"/>
    <circle fill="#292F33" cx="21.5" cy="17.5" r="1.5"/>
  </svg>
);

export const RoosterSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#DD2E44" d="M12 2c0 2-1 3-2 3s-2-1-2-3 1-2 2-2 2 1 2 2z"/>
    <path fill="#FFAC33" d="M28 20c0-5.523-4.477-10-10-10S8 14.477 8 20s4.477 10 10 10 10-4.477 10-10z"/>
    <circle fill="#292F33" cx="22.5" cy="18.5" r="1.5"/>
  </svg>
);

export const DogSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#D99E82"
          d="M31.034 14.374c3.508-.65 3.587-6.297-.051-6.254-2.847.034-2.56 2.795-2.945 2.252-.748-1.055-.989-3.769 1.862-4.894"/>
    <path fill="#C1694F" d="M28 20c0-5.523-4.477-10-10-10S8 14.477 8 20s4.477 10 10 10 10-4.477 10-10z"/>
    <circle fill="#292F33" cx="22" cy="18" r="1.5"/>
  </svg>
);

export const BoarSvg: FC<{ size?: number }> = ({size = 28}) => (
  <svg width={size} height={size} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="#C1694F"
          d="M33.359 13.254c1.434-3.462 2.06-11.534 1.262-12.004-.704-.416-5.641 1.084-8.34 3.205C23.883 2.909 21.085 2 18 2"/>
    <path fill="#D99E82" d="M28 20c0-5.523-4.477-10-10-10S8 14.477 8 20s4.477 10 10 10 10-4.477 10-10z"/>
    <circle fill="#292F33" cx="22.5" cy="18.5" r="1.5"/>
  </svg>
);

export const EASTERN_COLOR_SVGS: Record<string, FC<{ size?: number }>> = {
  rat: RatSvg,
  ox: OxSvg,
  tiger: TigerSvg,
  rabbit: RabbitSvg,
  dragon: DragonSvg,
  snake: SnakeSvg,
  horse: HorseSvg,
  sheep: GoatSvg,
  monkey: MonkeySvg,
  chicken: RoosterSvg,
  dog: DogSvg,
  pig: BoarSvg
};
